import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const getExportTask = async (exportTaskId) => {
    const res = await axios.get(`/api/v1/async_export_tasks/${exportTaskId}`);
    return res.data;
}

export const createModel1ExportTask = async (workgroupId, filters, data) => {
    const urlParams = createUrlParams(filters)
    const res = await axios.post(`/api/v1/async_export_tasks/${workgroupId}/export_models1?${urlParams.toString()}`, data);
    return res.data;
}

export const createModel23ExportTask = async (workgroupId, filters, data) => {
    const urlParams = createUrlParams(filters)
    const res = await axios.post(`/api/v1/async_export_tasks/${workgroupId}/export_models23?${urlParams.toString()}`, data);
    return res.data;
}

export const createIncidentExportTask = async (workgroupId, filters, data) => {
    const urlParams = createUrlParams(filters)
    const res = await axios.post(`/api/v1/async_export_tasks/${workgroupId}/export_incidents?${urlParams.toString()}`, data);
    return res.data;
}

export const createPeopleCaughtExportTask = async (workgroupId, filters, data) => {
    const urlParams = createUrlParams(filters)
    const res = await axios.post(`/api/v1/async_export_tasks/${workgroupId}/export_people_caught?${urlParams.toString()}`, data);
    return res.data;
}